/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValue
 */
export interface GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValue {
    /**
     * 
     * @type {string}
     * @memberof GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValue
     */
    deliveryCatalogId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValue
     */
    takeawayCatalogId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValue
     */
    onsiteCatalogId?: string | null;
}

/**
 * Check if a given object implements the GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValue interface.
 */
export function instanceOfGetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValue(value: object): value is GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValue {
    return true;
}

export function GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValueFromJSON(json: any): GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValue {
    return GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValueFromJSONTyped(json, false);
}

export function GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValue {
    if (json == null) {
        return json;
    }
    return {
        
        'deliveryCatalogId': json['deliveryCatalogId'] == null ? undefined : json['deliveryCatalogId'],
        'takeawayCatalogId': json['takeawayCatalogId'] == null ? undefined : json['takeawayCatalogId'],
        'onsiteCatalogId': json['onsiteCatalogId'] == null ? undefined : json['onsiteCatalogId'],
    };
}

export function GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValueToJSON(json: any): GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValue {
    return GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValueToJSONTyped(json, false);
}

export function GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValueToJSONTyped(value?: GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deliveryCatalogId': value['deliveryCatalogId'],
        'takeawayCatalogId': value['takeawayCatalogId'],
        'onsiteCatalogId': value['onsiteCatalogId'],
    };
}

